import React from 'react';

import { Header, Navbar, NavPills } from '@C';
import ErrorBoundary from '@C/Error';
import { RouteSetup } from '@C/Settings';

const routes = [
  {
    name: 'Reminder',
    path: '/settings/reminder-notifications',
    display: false,
  },
  {
    name: ' SMS',
    path: '/settings/sms',
    display: true,
  },
  {
    name: 'Profit Margin',
    path: '/settings/profit-margin',
  },
  {
    name: 'Shift Settings',
    path: '/settings/shift-settings',
    display: true,
  },
  {
    name: 'Reset Account',
    path: '/settings/reset-account',
  },
  {
    name: 'Data Migration',
    path: '/settings/data-migration',
    display: true,
  },
];

const Settings = () => {
  return (
    <main>
      <div className="page-wrapper">
        <Header title="App Settings" />
        <Navbar />
        <div className="page-content">
          <section className="page-components">
            <div className="page-title">
              <h1> App Settings</h1>
            </div>
            <ErrorBoundary>
              <NavPills routes={routes} />
              <RouteSetup />
            </ErrorBoundary>
          </section>
        </div>
      </div>
    </main>
  );
};

export { Settings };
